import { formatTimestampToShortDate } from '../resources/js/utils/formatTimestampToDate'
import {
    getAll,
    getByKey,
    put,
    deleteItem,
    clear,
    update,
} from './utils/transactionHelpers'

export const savePendingRequest = async requestData => {
    try {
        const id = Date.now()
        // Deep clone to avoid reference issues
        const sanitizedData = JSON.parse(JSON.stringify(requestData))

        // Ensure these important fields are preserved
        const equipmentId =
            sanitizedData.equipmentId ||
            sanitizedData.equipmentSFId ||
            sanitizedData.assetId ||
            sanitizedData.assetSalesforceId

        const requestToSave = {
            id,
            name: id,
            label: 'Pending Request',
            status: 'Pending',
            prettyDate: formatTimestampToShortDate(id),
            attemptCount: 0,
            ...sanitizedData,
            // Ensure these IDs are saved regardless of their location in the original object
            equipmentId: equipmentId,
            equipmentSFId: equipmentId,
            assetId: equipmentId,
        }

        await put('pendingRequests', requestToSave)
        return requestToSave
    } catch (error) {
        console.error('Error saving pending request:', error)
        throw error
    }
}

export const getPendingRequests = async () => {
    try {
        const result = await getAll('pendingRequests')
        return result.reverse() // Maintain existing reverse order
    } catch (error) {
        console.error('Error fetching pending requests:', error)
        return []
    }
}

export async function getPendingRequestById(requestId) {
    try {
        const result = await getByKey('pendingRequests', requestId)
        return result || null
    } catch (error) {
        console.error('Error retrieving pending request by ID:', error)
        throw error
    }
}

export const deletePendingRequest = async id => {
    try {
        await deleteItem('pendingRequests', id)
        console.log(`Pending request with ID ${id} deleted successfully.`)
    } catch (error) {
        console.error('Error deleting pending request:', error)
        throw error
    }
}

export const updatePendingRequestStatus = async (
    requestId,
    { status, error },
) => {
    try {
        await update('pendingRequests', requestId, data => ({
            ...data,
            status,
            error,
        }))
    } catch (err) {
        console.error('Error in updatePendingRequestStatus:', err)
        throw err
    }
}

export const updatePendingRequestAttempt = async (
    requestId,
    newAttemptCount,
) => {
    try {
        await update('pendingRequests', requestId, data => ({
            ...data,
            attemptCount: newAttemptCount + 1,
        }))
    } catch (err) {
        console.error('Error in updatePendingRequestAttempt:', err)
        throw err
    }
}

export const deleteAllPendingRequests = async () => {
    try {
        await clear('pendingRequests')
    } catch (error) {
        console.error('Error deleting all pending requests:', error)
        throw error
    }
}
